import { eye } from '../../assets/images/dashboard-business';
import styles from '../../components/LimitedLiability/BusinessAddres/BusinessAddress.module.css';
import useWindowDimensions from '../../hooks/useWindowDimension';
import { useAppSelector } from '../../app/hooks';
import moment from 'moment';
import { TRegInStorage, TRegistration } from '../../types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import useDebounce from '../../hooks/useDebounce';
import Button2 from '../global/Button2';
import { wqkgx } from '../../config/keys';
import PaymentModal from '../global/PaymentGatewayModal';
import CryptoJS from 'crypto-js';
import { hasARegistrationInLocalStorage } from '../../utils/setRegInfoInLocalStorage';
import { Link } from 'react-router-dom';
import { getModiefiedRegistrations } from '../../utils/statusTableFns';
import useSortRegistrations from '../../hooks/useSortRegistrations';

type TProps = {
  divWidth: string;
  registrations: (TRegistration | TRegInStorage)[];
  sortBy: string;
  search: string;
};
const StatusTable = ({ divWidth, registrations, sortBy, search }: TProps) => {
  const [show, setShow] = useState(false);
  const [start, setStart] = useState(0);
  const { width } = useWindowDimensions();
  const allPackagesAndPrice = useAppSelector((state) => state.packages?.packages);

  const getPrice = (packkage: number) => {
    const charge =
      allPackagesAndPrice?.find((item) => item?.id === packkage)?.price?.toLocaleString() ?? 0;
    return charge;
  };

  const hasPackageBeenDeleted = useCallback(
    (id: number) => {
      const item = allPackagesAndPrice?.find((it) => it?.id === id);
      return Object.keys(item ?? {}).length === 0;
    },
    [allPackagesAndPrice],
  );

  const debouncedSearch = useDebounce(search, 300);
  const { sortedRegistrations } = useSortRegistrations({
    debouncedSearch,
    search,
    sortBy,
    totalRegistrations: registrations,
  });

  useEffect(() => {
    if (debouncedSearch) {
      setStart(0);
    }
  }, [debouncedSearch]);

  return (
    <div>
      <div>
        <div
          // style={{
          //   width: width < 1280 ? `${divWidth}px` : `${Math.round(1 * Number(divWidth))}px`,
          // }}
          className={[
            `overflow-x-auto whitespace-nowrap overflow-y-visible`,
            styles.hideScroll,
          ].join(' ')}
        >
          <table
            className={`text-xs border-separate border-spacing-x-0 border-spacing-y-2 w-[100%] mr-[2rem]`}
          >
            <thead className='bg-[#D4F1FC] p-3'>
              <tr>
                <th className='p-2'>S/N</th>
                <th className='p-2'>
                  Preferred <br />
                  Business Name 1
                </th>
                <th className='p-2'>
                  Business <br />
                  Segment
                </th>
                <th className='p-2'>
                  Business <br />
                  Nature
                </th>
                <th className='p-2'>Title</th>
                <th className='p-2'>
                  Business <br />
                  Description
                </th>

                <th className='p-2'>Amount</th>
                <th className='p-2'>Date Created</th>
                <th className='p-2'>
                  Estimated <br />
                  Completion Date
                </th>
                <th className='p-2'>Status</th>
                <th className='p-2'>Action</th>
              </tr>
            </thead>

            <tbody className=' bg-[whitesmoke] font-[500]'>
              {sortedRegistrations.slice(start, start + 4)?.map((data, index) => (
                <tr key={data?.createdAt} className='p-2 bg-[white] drop-shadow-lg'>
                  <td className='p-2 ' data-label='S/N'>
                    <div>{start + index + 1}.</div>
                  </td>
                  <td className='p-2' data-label='Preferred Business Name 1'>
                    <div>{data?.businessNameOptions?.[0] ?? '__'}</div>
                  </td>
                  <td className='p-2' data-label='Business Segment'>
                    <div>{data?.businessSegment ?? '__'}</div>
                  </td>
                  <td className='p-2' data-label='Business Nature'>
                    <div>{data?.businessNature ?? '__'}</div>
                  </td>

                  {data?.type === 'TRegInStorage' ? (
                    <>
                      <td className='p-2' data-label='Title'>
                        <div>
                          {data?.title ? decodeURIComponent(data?.title?.replace('+', ' ')) : '__'}
                        </div>
                      </td>
                      <td className='p-2' data-label='Business Description'>
                        <div className='w-[200px] overflow-x-scroll no-scrollbar'>
                          {data?.businessDesc ?? '__'}
                        </div>
                      </td>
                      <td className='p-2' data-label='Amount'>
                        <div>{getPrice(Number(data?.packageId ?? ''))}</div>
                      </td>
                      <td className='p-2 w-[100px]' data-label='Date Created'>
                        <div>{moment(data?.createdAt).format('MM-DD-YYYY')}</div>
                      </td>
                      <td className='p-2' data-label='Estimated Completion Date'>
                        <div>{moment(data?.createdAt).add(15, 'days').format('MM-DD-YYYY')}</div>
                      </td>
                      <td className={`p-2`} data-label='Status'>
                        <div className={`p-2 rounded-sm bg-opacity-10 bg-[#F8B400] text-center`}>
                          {data?.status}
                        </div>
                      </td>
                      <td className='p-2' data-label='Action'>
                        <div className=''>
                          <Button2
                            theme='tertiary'
                            className='!py-1 !px-4 !text-[10px] w-[100px]'
                            onClick={() => {
                              !hasPackageBeenDeleted(Number(data?.packageId))
                                ? window.location.replace(data?.link ?? '')
                                : null;
                            }}
                          >
                            CONTINUE
                          </Button2>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className='p-2' data-label='Title'>
                        <div>
                          {data?.business_registration_package?.activeServiceChargeLog?.title ??
                            '__'}
                        </div>
                      </td>
                      <td className='p-2' data-label='Business Description'>
                        <div className='w-[200px] overflow-x-scroll no-scrollbar'>
                          {data?.businessDescription}
                        </div>
                      </td>
                      <td className='p-2' data-label='Amount'>
                        <div>{getPrice(data?.business_registration_package?.packageId)}</div>
                      </td>
                      <td className='p-2 w-[100px]' data-label='Date Created'>
                        <div>
                          {moment(data?.business_registration_package?.createdAt).format(
                            'MM-DD-YYYY',
                          )}
                        </div>
                      </td>
                      <td className='p-2' data-label='Estimated Completion Date'>
                        <div>
                          {moment(data?.business_registration_package?.createdAt)
                            .add(15, 'days')
                            .format('MM-DD-YYYY')}
                        </div>
                      </td>
                      <td className={`p-2`} data-label='Status'>
                        <div
                          className={`p-2 rounded-sm bg-opacity-10 text-center ${
                            data?.business_registration_package?.paid
                              ? 'bg-[#049E26]'
                              : 'bg-[#F8B400]'
                          }`}
                        >
                          {data?.business_registration_package?.paid ? 'PAID' : 'NOT PAID'}
                        </div>
                      </td>
                      <td className='p-2' data-label='Action'>
                        {!data?.business_registration_package?.paid && (
                          <div className=''>
                            {/* <img src={eye} alt='' className='h-[14px] w-[20px]' /> */}
                            <Button2
                              theme='tertiary'
                              className='!py-1 !px-4 !text-[10px] w-[100px]'
                              onClick={() => {
                                setShow(true);
                                localStorage.setItem(
                                  'businessId',
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(data?.business_registration_package?.entId),
                                    wqkgx,
                                  ).toString(),
                                );
                                localStorage.setItem(
                                  'package',
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(data?.business_registration_package?.package),
                                    wqkgx,
                                  ).toString(),
                                );
                                localStorage.setItem(
                                  'package-id',
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(data?.business_registration_package?.packageId),
                                    wqkgx,
                                  ).toString(),
                                );
                              }}
                            >
                              MAKE PAYMENT
                            </Button2>
                            {/* <div>Continue</div> */}
                          </div>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='mt-3 flex justify-between'>
          {start > 0 && (
            <div
              className='cursor-pointer bg-[red] py-[4px] px-[6px] text-[white] text-xs rounded-sm'
              onClick={() => setStart(start - 4)}
            >
              {`< Prev`}
            </div>
          )}
          {start + 4 < sortedRegistrations?.length && (
            <div
              className='cursor-pointer bg-[#028789] py-[4px] px-[6px] text-[white] text-xs rounded-sm'
              onClick={() => setStart(start + 4)}
            >
              {`Next >`}
            </div>
          )}
        </div>
      </div>

      <PaymentModal show={show} setShow={setShow} redirect={false} />
    </div>
  );
};

export default StatusTable;
